import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faPencil, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import {
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
  faEnvelope,
  faPhone,
  faTrash,
  faUser,
} from "@fortawesome/fontawesome-free-solid";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../../components/Modal";
import { setProfileBoxAction } from "../../../redux/auth/auth-slice";
import { IoIosSearch } from "react-icons/io";
import {
  setEditDriver,
  setSearchDriver,
} from "../../../redux/driver/driver-slice";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import axios from "axios";

export default function DriversPage() {
  const dispatch = useDispatch();
  const { user, token } = useSelector((state) => state.auth);
  const { allDrivers, editDriver, searchDriver, isLoading } = useSelector(
    (state) => state.driver,
  );

  const [driverPage, setdriverPage] = useState(1);
  const [resetPassword, setresetPassword] = useState();
  const [deleteDriver, setdeleteDriver] = useState(false);
  const [totalDriversCnt, settotalDriversCount] = useState();
  const [driveraddModal, setdriveraddModal] = useState(false);
  const [driverEditModal, setDriverEditModal] = useState(false);
  const [driverCreateInput, setdriverCreateInput] = useState({
    name: "",
    countryCode: "",
    contactNumber: "",
    password: "",
    email: "",
    carPlateNo: "",
    carLicenseNo: "",
  });

  const totalDriversCount = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/drivers/totalDriversCount`,
        {
          headers: {
            Authorization: token,
          },
          withCredentials: true,
        },
      );

      settotalDriversCount(response.data.count);
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.msg || "Something went wrong");
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      totalDriversCount();
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [token]);

  useEffect(() => {
    dispatch({
      type: "GET_ALL_DRIVERS",
      payload: { token, page: driverPage },
    });
  }, [driverPage, token]);

  const createDriver = (e) => {
    e.preventDefault();
    if (
      driverCreateInput.name.length === 0 ||
      driverCreateInput.countryCode.length === 0 ||
      driverCreateInput.contactNumber.length === 0 ||
      driverCreateInput.password.length === 0
    ) {
      toast.warning("It seems you haven't filled all the required fields");
      return;
    }

    if (driverCreateInput.name === "") {
      toast.warning("Please Enter Driver Name");
    } else if (driverCreateInput.countryCode === "") {
      toast.warning("Please Enter Country Code");
    } else if (driverCreateInput.contactNumber === "") {
      toast.warning("Please Enter ContactNumber");
    } else if (driverCreateInput.password === "") {
      toast.warning("Please Enter Password");
    } else if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
        driverCreateInput.email,
      ) === false
    ) {
      toast.warning("Please enter a valid email");
      return;

      // The regex.test() method is used to test for a match in a string.
      // The method returns true if it finds a match; otherwise, it returns false.
    } else if (
      driverCreateInput.password.length != 0 &&
      driverCreateInput.password.length < 8
    ) {
      toast.warning("Please enter password of length 8 atleast");
    } else {
      const payload = {
        name: driverCreateInput?.name,
        countryCode: driverCreateInput?.countryCode,
        contactNumber: driverCreateInput?.contactNumber,
        password: driverCreateInput?.password,
        email: driverCreateInput?.email,
        carPlateNo: driverCreateInput?.carPlateNo,
        carLicenseNo: driverCreateInput?.carLicenseNo,
        companyId: user?.companyid,
      };

      console.log(payload);

      dispatch({
        type: "REGISTER_DRIVER",
        payload: {
          body: payload,
          token,
        },
      });
      setdriveraddModal(false);
      setdriverCreateInput({
        name: "",
        countryCode: "",
        contactNumber: "",
        password: "",
        email: "",
        carPlateNo: "",
        carLicenseNo: "",
      });
    }
  };

  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (searchTerm !== "") {
      dispatch({
        type: "SEARCH_DRIVER",
        payload: {
          searchTerm: searchTerm,
          companyId: user?.companyid,
        },
      });
    } else {
      dispatch(
        setSearchDriver({
          searchDriver: [],
        }),
      );
    }
  }, [searchTerm]);

  useEffect(() => {
    dispatch(setProfileBoxAction({ profileBoxAction: false }));
  }, []);

  useEffect(() => {
    dispatch({ type: "GET_ALL_DRIVERS", payload: { token, page: driverPage } });
  }, []);

  console.log("Driver Inpute ====>", driverCreateInput);

  const handleReset = () => {
    setdriverCreateInput((p) => ({
      ...p,
      contactNumber: "",
      password: "",
    }));
  };

  return (
    <>
      {driveraddModal && (
        <>
          <div className="fixed left-0 top-0 z-50 flex h-screen w-screen items-center justify-center bg-black bg-opacity-50"></div>

          <Modal
            tag="add"
            heading="Add Driver"
            cancelOnClick={() => {
              setdriveraddModal(false);
              setdriverCreateInput({
                name: "",
                countryCode: "",
                contactNumber: "",
                password: "",
                email: "",
                carPlateNo: "",
                carLicenseNo: "",
              });
            }}
            label="Save"
            isDriverCreate={true}
            submitOnClick={createDriver}
            driverName={driverCreateInput?.name}
            driverCarPlateNumber={driverCreateInput?.carPlateNo}
            driverCarLicenseNo={driverCreateInput?.carLicenseNo}
            driverEmail={driverCreateInput?.email}
            driverCountryCode={driverCreateInput?.countryCode}
            driverContactNumber={driverCreateInput?.contactNumber}
            driverPassword={driverCreateInput?.password}
            setCountryCodeChange={(e) => {
              console.log("country", e);
              setdriverCreateInput({
                ...driverCreateInput,
                countryCode: e.dial_code,
              });
            }}
            driverNameInput={(e) => {
              setdriverCreateInput({
                ...driverCreateInput,
                name: e.target.value,
              });
            }}
            carPlateInput={(e) => {
              setdriverCreateInput({
                ...driverCreateInput,
                carPlateNo: e.target.value,
              });
            }}
            carLicenseInput={(e) => {
              setdriverCreateInput({
                ...driverCreateInput,
                carLicenseNo: e.target.value,
              });
            }}
            countryCodeInput={(e) => {
              setdriverCreateInput({
                ...driverCreateInput,
                countryCode: e.target.value,
              });
            }}
            contactNumberInput={(e) => {
              setdriverCreateInput({
                ...driverCreateInput,
                contactNumber: e.target.value,
              });
            }}
            driverEmailInput={(e) => {
              setdriverCreateInput({
                ...driverCreateInput,
                email: e.target.value,
              });
            }}
            driverPasswordInput={(e) => {
              const length = e.target.value?.length;
              if (e.target.value[length - 1] === " ") {
                // toast.warn("No space allowed in password");
                return;
              }
              setdriverCreateInput({
                ...driverCreateInput,
                password: e.target.value,
              });
            }}
            handleReset={handleReset}
          />
        </>
      )}

      {driverEditModal && (
        <>
          <div className="fixed left-0 top-0 z-50 flex h-screen w-screen items-center justify-center bg-black bg-opacity-50"></div>
          <Modal
            handleReset={handleReset}
            isDriverModalEdit={true}
            tag="edit"
            heading="Edit Driver"
            label="Edit"
            // setEditCountryCodeChange={(e)=>{
            //   console.log("country",e)

            // }}
            cancelOnClick={() => {
              setDriverEditModal(false);
            }}
            submitOnClick={() => {
              dispatch({
                type: "EDIT_DRIVER",
                payload: {
                  driverId: editDriver?._id,
                  body: editDriver,
                },
              });
              setDriverEditModal(false);
            }}
          />
        </>
      )}

      <div
        className="grid h-full grid-rows-[auto_auto_auto_1fr] bg-black py-2"
        onClick={() => {
          dispatch(setProfileBoxAction({ profileBoxAction: false }));
        }}
      >
        {/* screen below sm */}
        <div className="sm:hidden">
          <div className="mx-5 mt-10 flex items-center justify-between space-x-10 md:mx-16 md:mt-0 xl:mx-32">
            <div className="w-full xs:w-1/2 xl:pr-5 3xl:pl-12 3xl:pr-20">
              <div className="relative w-full 3xl:w-auto">
                <input
                  className="w-full rounded-full border border-slate-700/70 bg-slate-700/30 px-10 py-1.5 text-white focus:border-slate-700/60 focus:outline-none"
                  placeholder="Search Contacts"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                />
                <IoIosSearch className="absolute left-3 top-3 text-white" />
              </div>
            </div>

            <div className="w-44 text-center xs:w-auto">
              <div
                onClick={() => {
                  setdriveraddModal(true);
                }}
                className="flex cursor-pointer justify-center space-x-1 rounded-full border border-[#144EE3] bg-[#144EE3] px-4 py-2 text-sm font-semibold text-white shadow-sm shadow-blue-700"
              >
                Add Driver
              </div>
            </div>
          </div>

          <div className="mt-3 px-5 font-semibold text-white sm:text-lg md:text-xl 2md:text-2xl">
            All Drivers Details
          </div>
        </div>

        {/* screen above sm */}
        <div className="mt-6 hidden sm:block">
          <div className="mx-10 mt-10 flex items-center md:mx-16 md:mt-0 xl:mx-32">
            <div className="flex w-1/3 items-center space-x-2">
              <div className="font-semibold text-white sm:text-lg md:text-xl 2md:text-2xl">
                All Drivers Details
              </div>
            </div>

            <div className="w-3/5 xl:pr-5 3xl:pl-12 3xl:pr-20">
              <div className="relative w-full 3xl:w-auto">
                <input
                  className="w-full rounded-full border border-slate-700/70 bg-slate-700/30 px-10 py-1.5 text-white focus:border-slate-700/60"
                  placeholder="Search Contacts"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                />
                <IoIosSearch className="absolute left-3 top-3 text-white" />
              </div>
            </div>

            <div className="flex w-1/3 justify-end">
              <div
                onClick={() => {
                  setdriveraddModal(true);
                }}
                className="flex cursor-pointer space-x-1 rounded-full border border-[#144EE3] bg-[#144EE3] px-8 py-1.5 text-base font-semibold text-white shadow-sm shadow-blue-700"
              >
                <div>Add Driver</div>
                <div>
                  <FontAwesomeIcon icon={faAdd} className="text-xs" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mx-36 mt-5 flex items-center justify-end space-x-3">
          <button
            onClick={() => {
              if (driverPage > 1) {
                setdriverPage(driverPage - 1);
                dispatch({
                  type: "GET_ALL_DRIVERS",
                  payload: { token, page: driverPage },
                });
              }
            }}
          >
            <FontAwesomeIcon
              icon={faArrowAltCircleLeft}
              className={`text-xl ${
                driverPage > 1 ? `text-white` : `text-gray-500`
              } `}
            />
          </button>
          <div>
            {driverPage} /{" "}
            {totalDriversCnt ? Math.round(totalDriversCnt / 20) : "Loading..."}
          </div>
          <button
            onClick={() => {
              if (driverPage < Math.round(totalDriversCnt / 20)) {
                setdriverPage(driverPage + 1);
                dispatch({
                  type: "GET_ALL_DRIVERS",
                  payload: { token, page: driverPage },
                });
              }
            }}
          >
            <FontAwesomeIcon
              icon={faArrowAltCircleRight}
              className={`text-xl ${
                driverPage < Math.round(totalDriversCnt / 20)
                  ? `text-white`
                  : `cursor-not-allowed text-gray-500`
              } `}
            />
          </button>
        </div>

        <div className="mt-5 w-full bg-gradient-to-r from-[#111111] via-[#848484] to-[#111111] py-[0.4px]" />

        <div className="mt-4 overflow-hidden xl:px-16">
          <div className="mx-5 h-full rounded-lg sm:mx-10 md:mx-16 md:border-2 md:border-white/30">
            <div className="h-full overflow-y-scroll rounded-lg pb-2 shadow-md shadow-[#0f0e0e] max-md:scrollbar-none md:bg-[#121010] md:scrollbar">
              {/* Heading */}
              <div className="sticky top-0 hidden w-full justify-between rounded-t-lg bg-gradient-to-r from-[#000000] from-50% via-[#444444] via-50% to-[#000000] to-50% px-6 py-2 text-base font-semibold text-white/60 md:flex xl:px-10">
                <div className="w-[30%]">Name</div>
                <div className="w-[30%]">Contact Number</div>
                <div className="w-[30%]">Email ID</div>
                <div className="w-[10%] pr-6 text-right">Action</div>
              </div>

              {/* Overflow Scroll */}
              {isLoading ? (
                <div className="loading loading-bars loading-lg absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform text-slate-600" />
              ) : (
                <>
                  {(searchDriver.length > 0 ? searchDriver : allDrivers)?.map(
                    (singleDriver) => {
                      return (
                        <div key={singleDriver?._id}>
                          <DriverItem
                            editDriverOnClick={() => {
                              setDriverEditModal(singleDriver?._id);
                              dispatch(
                                setEditDriver({ editDriver: singleDriver }),
                              );
                            }}
                            drivername={singleDriver?.name}
                            carPlateNo={singleDriver?.carPlateNo}
                            carLicenseNo={singleDriver?.carLicenseNo}
                            email={singleDriver?.email}
                            contact={
                              singleDriver?.countryCode +
                              " " +
                              singleDriver?.contactNumber
                            }
                            deleteDriverOnClick={() => {
                              setdeleteDriver(singleDriver?._id);
                            }}
                            resetPasswordOnClick={() => {
                              setresetPassword(singleDriver?._id);
                            }}
                          />
                          {singleDriver?._id === deleteDriver && (
                            <>
                              <div className="fixed left-0 top-0 z-20 flex h-screen w-screen items-center justify-center bg-black bg-opacity-50"></div>
                              <div className="absolute left-1/2 top-1/2 z-30 -translate-x-1/2 -translate-y-1/2 transform rounded-xl border-2 border-white/40 bg-gradient-to-b from-black to-neutral-800 px-12 py-10 text-center shadow xl:px-16">
                                <div className="mb-5 flex justify-center">
                                  <div className="relative h-14 w-14 rounded-full bg-zinc-800">
                                    <FontAwesomeIcon
                                      icon={faTrashCan}
                                      className="absolute left-[18px] top-3.5 h-7 w-5 text-white"
                                    />
                                  </div>
                                </div>
                                <div className="flex justify-center space-x-2 text-xl font-semibold text-white sm:text-xl md:text-2xl">
                                  Are you sure you want to delete this driver?
                                </div>
                                <div className="mt-9 flex justify-center space-x-6 text-white">
                                  <button
                                    className="rounded-md border border-gray-700 bg-[#181E29] px-4 py-1.5 text-lg font-medium text-gray-100 hover:bg-[#161a22] sm:px-7 sm:py-2"
                                    onClick={() => {
                                      setdeleteDriver("");
                                    }}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    className="flex items-center space-x-2 rounded-lg border border-red-700 bg-red-600 px-4 py-1.5 text-lg font-medium text-white hover:bg-red-500 hover:text-white sm:px-7 sm:py-2"
                                    onClick={() => {
                                      dispatch({
                                        type: "DELETE_DRIVER",
                                        payload: {
                                          token,
                                          id: singleDriver?._id,
                                        },
                                      });
                                      setdeleteDriver("");
                                    }}
                                  >
                                    <FontAwesomeIcon
                                      icon={faTrashCan}
                                      className="h-6 w-3.5"
                                    />
                                    <h2>Delete</h2>
                                  </button>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      );
                    },
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export const DriverItem = ({
  drivername,
  contact,
  email,
  resetPasswordOnClick,
  editDriverOnClick,
  deleteDriverOnClick,
}) => {
  const dispatch = useDispatch();
  return (
    <>
      <div className="md:hidden">
        <div
          id="grad"
          className="mt-2 flex items-center justify-between space-x-2 rounded-xl border-2 border-gray-500 px-6 py-3 text-white/70 xl:space-x-0 xl:px-10"
          onClick={() => {
            dispatch(setProfileBoxAction({ profileBoxAction: false }));
          }}
        >
          <div className="space-y-1.5">
            <div className="flex w-full items-center space-x-3 truncate text-base font-semibold uppercase text-white/90">
              <FontAwesomeIcon icon={faUser} className="text-white" />
              <h2 className="w-40 truncate">{drivername}</h2>
            </div>
            <div className="flex w-full items-center space-x-3 truncate text-sm font-normal text-white/90">
              <FontAwesomeIcon icon={faPhone} />
              <h2>{contact}</h2>
            </div>
            <div className="flex items-center space-x-3 pr-5 text-sm font-normal text-white/90 xl:pr-0">
              <FontAwesomeIcon icon={faEnvelope} />
              <h2 className="w-48 truncate">{email}</h2>
            </div>
          </div>
          <div className="flex w-[10%] justify-end space-y-2">
            <div className="flex items-center space-x-2">
              {/* <div
              onClick={resetPasswordOnClick}
              data-tooltip-id="my-tooltip-1"
              className="bg-slate-800 border border-slate-600 w-10 h-10 rounded-full text-center py-1.5 cursor-pointer"
            >
              <FontAwesomeIcon icon={faLock} />
            </div> */}

              <div>
                <div
                  onClick={editDriverOnClick}
                  className="h-10 w-10 cursor-pointer rounded-full border border-slate-600 bg-slate-800 py-1.5 text-center md:h-8 md:w-8 md:py-0.5 2md:h-10 2md:w-10 2md:py-1.5"
                  data-tooltip-id="edit-driver"
                  data-tooltip-content="Edit Driver"
                >
                  <FontAwesomeIcon icon={faPencil} />
                </div>
                <Tooltip id="edit-driver" />
              </div>
              <div>
                <div
                  onClick={deleteDriverOnClick}
                  className="h-10 w-10 cursor-pointer rounded-full border border-slate-600 bg-slate-800 py-1.5 text-center md:h-8 md:w-8 md:py-0.5 2md:h-10 2md:w-10 2md:py-1.5"
                  data-tooltip-id="delete-driver"
                  data-tooltip-content="Delete Driver"
                >
                  <FontAwesomeIcon icon={faTrash} className="text-red-800" />
                </div>
                <Tooltip id="delete-driver" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="hidden md:block">
        <div
          className="mt-2 items-center justify-between space-x-2 px-6 py-1.5 text-white/70 md:flex xl:space-x-0 xl:px-10"
          onClick={() => {
            dispatch(setProfileBoxAction({ profileBoxAction: false }));
          }}
        >
          <div className="w-[30%] space-y-2 truncate">{drivername}</div>
          <div className="w-[30%] space-y-2">{contact}</div>
          <div className="w-[30%] space-y-2 truncate pr-5 xl:pr-0">{email}</div>
          <div className="flex w-[10%] justify-end space-y-2">
            <div className="flex items-center space-x-2">
              {/* <div
              onClick={resetPasswordOnClick}
              data-tooltip-id="my-tooltip-1"
              className="bg-slate-800 border border-slate-600 w-10 h-10 rounded-full text-center py-1.5 cursor-pointer"
            >
              <FontAwesomeIcon icon={faLock} />
            </div> */}

              <div>
                <div
                  onClick={editDriverOnClick}
                  className="h-10 w-10 cursor-pointer rounded-full border border-slate-600 bg-slate-800 py-1.5 text-center md:h-8 md:w-8 md:py-0.5 2md:h-10 2md:w-10 2md:py-1.5"
                  data-tooltip-id="edit-driver"
                  data-tooltip-content="Edit Driver"
                >
                  <FontAwesomeIcon icon={faPencil} />
                </div>
                <Tooltip id="edit-driver" />
              </div>
              <div>
                <div
                  onClick={deleteDriverOnClick}
                  className="h-10 w-10 cursor-pointer rounded-full border border-slate-600 bg-slate-800 py-1.5 text-center md:h-8 md:w-8 md:py-0.5 2md:h-10 2md:w-10 2md:py-1.5"
                  data-tooltip-id="delete-driver"
                  data-tooltip-content="Delete Driver"
                >
                  <FontAwesomeIcon icon={faTrash} className="text-red-800" />
                </div>
                <Tooltip id="delete-driver" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-grad hidden w-full md:block">
        <div className="mx-0 my-2 bg-gradient-to-r from-[#111111] via-[#848484] to-[#111111] py-[1px]"></div>
      </div>
    </>
  );
};
